// Shared between the app-level support connection and the sidebar, which
// remounts on navigation. Navigating must not reset an idle staff member.
export const supportActivity = { lastAt: Date.now(), confirmedAt: 0 };
export const SUPPORT_IDLE_MS = 5 * 60_000;
